import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, switchMap, timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { Attachment, Word } from '../models';
import * as data from '../../../assets/files/mimetypes.json';

@Injectable()

export class S3Service {

  constructor(
    private httpClient: HttpClient,
    private apiService: ApiService,
  ) { }

  private formatErrors(error: any) {
    return throwError(error);
  }
  /**
   * attraverso il parametro si richiede tutti i dati con una http get
   * @param  {string} path
   */
  public all(path: string) {
      return this.httpClient.get(`${
        environment.wmaiAPIServer
        }` + '/path?' + path).pipe(map(response => response['data']));
  }
  /**
   * si ottiene il tipo documento attraverso il parametro
   * @param  {string} keyword
   */
  getDocTypes(keyword: string): Observable<Word[]> {
    return this.httpClient.get(`${
      environment.wmaiAPIServer
      }` + '/words?keyword=' + keyword).pipe(map(response => response['data']));
  }
  /**
   * si crea un oggetto form data con il parametro del form e si effettua una post
   * @param  {FormData} formData
   */
  create(formData: FormData) {
    return this.httpClient.post(environment.wmaiAPIServer + '/resource', formData);
  }
  /**
   * si elimina la risorsa attraverso il parametro passato
   * @param  {number} fileId
   */
  delete(fileId: number) {
    return this.httpClient.delete(environment.wmaiAPIServer + '/resource/' + fileId);
  }
}
